import { CSSProperties, FC, useEffect, useState } from 'react';
import styles from './CopyButton.module.scss';
import { withStyles, MaterialSymbol } from 'vopay';

const cn = withStyles(styles);

type CopyButtonProps = { content: string | number; color?: CSSProperties['color'] };

const PULSE_DURATION_MS = 200;

const CopyButton: FC<CopyButtonProps> = ({ content, color = 'hsla(216, 100%, 59%, 1)' }) => {
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (animating) {
      const timeout = setTimeout(() => {
        setAnimating(false);
      }, PULSE_DURATION_MS);

      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [animating]);

  return (
    <button
      type="button"
      style={{
        '--duration': `${PULSE_DURATION_MS}ms`,
      }}
      className={cn('copyButton', animating && 'animating')}
      onClick={() => {
        setAnimating(true);
        navigator.clipboard.writeText(content.toString());
      }}
    >
      <MaterialSymbol icon="content_copy" size="24px" color={color} className={cn('icon')} />
    </button>
  );
};

export default CopyButton;
